import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ARTICLE_LIST,
  ARTICLE_COUNT,
  AGENDA_CATEGORY_LIST
} from 'manager/http-constants';
import { Table } from 'primeng/table';
import { DICVALUES_API_CONSTANT } from 'src/app/shared/constant/api-constant';
import { CONSTANT } from 'src/app/shared/constant/constant';
import { LoadingState } from 'src/app/shared/html-parts/loading/loading-state';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { PlatformComponent } from '../platform.component';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-j101',
  templateUrl: './j101.component.html',
  styleUrls: ['./j101.component.scss', '../platform.component.scss'],
})

/**
 * 事例紹介記事一覧
 */
export class J101Component extends PlatformComponent {
  // 画面.検索フォーム
  j101SearchForm: FormGroup = this.formBuilder.group({
    // フリーワード検索
    freeword: CONSTANT.EMPTY_STRING,
  });

  /** テーブル状態 */
  @ViewChild('table') table: Table;

  // 事例紹介記事結果リスト
  resultArticleDataList: object[] = [];

  // 事例紹介記事件数格納先
  countArticleData = 0;

  // ソート順
  sortOptions = [
                  {label: '新しい順', value: '!create_datetime'}
                ];
  // ソート降順昇順設定
  sortOrder: number;
  // ソート項目
  sortField: string;
  // ソート初期値
  sortKey: string;
  // セッション保存名
  sessionTagName = 'j101SearchConditions';

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private titleService: Title
  ) {
    super(route, commonService, dbOperationService, loadingState);
    this.titleService.setTitle('地方創生SDGs官民連携マッチングシステム｜内閣府');
  }

  ngOnInit(): void {
    // 辞書値リストを取得
    this.getSpecCodeList(1, 2, 3);

    // 課題カテゴリを取得
    this.getAgendaCategoryList();

    // 初期処理:クエリパラメータの設定
    this.setQueryParams();

    // 事例紹介記事結果を取得
    this.getResultArticleDataList();

    // ソート順を設定
    this.sortKey = this.sortOptions[0].value;
  }

  /**
   * 初期処理:クエリパラメータの設定
   */
  private setQueryParams(): void {
    // クエリパラメータ.会員種別
    {
      // クエリパラメータ.会員種別を取得
      const classId = this.route.snapshot.queryParams.class_id;

      // 会員種別が存在するか否か
      if (classId) {
        // 会員種別が存在する場合

        // 会員種別を画面.検索フォームに格納
        this.j101SearchForm
          .get('class_id')
          .setValue(classId.split(CONSTANT.COMMA));
      }
    }

    // クエリパラメータ.カテゴリ
    {
      // クエリパラメータ.カテゴリを取得
      const category = this.route.snapshot.queryParams.category;

      // カテゴリが存在するか否か
      if (category) {
        // カテゴリが存在する場合

        // カテゴリを画面.検索フォームに格納
        this.j101SearchForm
          .get('category')
          .setValue(category.split(CONSTANT.COMMA));
      }
    }
  }

  /**
   * 事例紹介記事結果を取得
   */
  public getResultArticleDataList(screenSearchFlg?: boolean, flg?: boolean): void {
    // 画面.検索フォームから検索条件を取得
    // ※値渡し
    let j101SearchForm: any = JSON.parse(
      JSON.stringify(this.j101SearchForm.value)
    );
    // 検索フォームが空の場合、セッションに保持している検索条件を設定
    if (!this.checkSetConditions(j101SearchForm) && !screenSearchFlg && !flg){
      const sessionSearchForm = JSON.parse(sessionStorage.getItem(this.sessionTagName));
      // セッションに値がなければ設定しない
      if (this.checkSetConditions(sessionSearchForm)){
        // 画面の検索条件に反映する
        this.j101SearchForm.setValue(sessionSearchForm);
        // 検索条件に設定する
        j101SearchForm = JSON.parse(
          JSON.stringify(this.j101SearchForm.value)
        );
      }
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(ARTICLE_LIST);

    // 事例紹介記事一覧を取得
    this.dbOperationService
      .getNoTemplateData(ARTICLE_LIST, j101SearchForm, true)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          // 事例紹介記事結果を格納
          this.resultArticleDataList = response.body;
          if (flg){
            const value = this.sortKey;
            this.onSortChange2(value);
          }
        } else {
          this.resultArticleDataList = [];
        }
        // 検索条件を保持
        sessionStorage.setItem(this.sessionTagName, JSON.stringify(this.j101SearchForm.value));

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, ARTICLE_LIST);
      });

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(ARTICLE_COUNT);

    // 事例紹介記事件数を取得
    this.dbOperationService
      .getNoTemplateData(ARTICLE_COUNT, null, true)
      .subscribe((response) => {
        // 事例紹介記事件数を格納
        this.countArticleData = response.body.count;
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, ARTICLE_COUNT);
      });

    // テーブル状態が存在するか否か
    if (this.table) {
      // テーブル状態が存在する場合

      // テーブル状態をリセット
      this.table.first = 0;
    }

    // 検索時にページアンカーへ遷移
    if (screenSearchFlg){
      this.jumpTop();
    }
  }

  /**
   * 検索条件が設定されているかチェックする
   * @param conditions 検索条件
   * @returns boolean true:設定あり / false:未設定
   */
  public checkSetConditions(conditions: any): boolean {
    // 検索条件が存在するかチェック
    if (conditions === undefined || conditions === null){
      return false;
    } else {
      // 検索条件が設定されているかチェック
      if (conditions.freeword){
        return true;
      }
    }
    return false;
  }

  /**
   * ソート順の設定を一覧に反映する
   * @param event
   */
  public onSortChange = event => {
    const value = event.value;
    this.onSortChange2(value);
  }

  /**
   * ソート順設定
   */
  public onSortChange2 = (value: string | string[]) => {
    if (value.indexOf('!') === 0) {
      if (value === '!create_datetime'){
        this.resultArticleDataList.sort((a, b) => (a['create_datetime'] > b['create_datetime'] ? -1 : 1))
      }
      else if(value === '!access_count'){
        this.resultArticleDataList.sort((a, b) => {
          if (parseFloat(a['access_count']) !== parseFloat(b['access_count'])){
            return (parseFloat(a['access_count']) > parseFloat(b['access_count']) ? -1 : 1);
          }
          if (a['create_datetime'] !== b['create_datetime']){
            return (a['create_datetime'] > b['create_datetime'] ? -1 : 1);
          }
        });
      }
      else if (value === '!excellent_tag'){
        this.resultArticleDataList.sort((a, b) => {
          if (a['excellent_tag'] !== b['excellent_tag']){
            return (a['excellent_tag'] > b['excellent_tag'] ? -1 : 1);
          }
          if (a['create_datetime'] !== b['create_datetime']){
            return (a['create_datetime'] > b['create_datetime'] ? -1 : 1);
          }
        });
      }
    }
  }

  /**
   * 更新日時が一ヶ月以内課のチェック
   * @param dateString 更新日時
   */
  public isWithinLastMonth(dateString: string | undefined): boolean {
    const updateDate = dateString ? new Date(dateString) : null;
    if (!updateDate) { return false; }

    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    updateDate.setHours(0, 0, 0, 0);
    oneMonthAgo.setHours(0, 0, 0, 0);
    return updateDate >= oneMonthAgo;
  }

}
